<div *ngIf='componentReady' class='NextServiceDateDialog'>
  <app-table [columns]='tableColumns' [dataSourceParams]='dataSourceParams' [dataSource]='dataSource'
             [filterGroups]='tableFilters'></app-table>
</div>